export default "__VITE_ASSET__C4cA_3Kj__"